import React from 'react'
import Header from './Header'
import "../Css/home.css"
import CreateToken from './Ethereum/CreateToken'
import Footer from './Footer'


export default function Home(props) {
    return (
        <>
            <div>
                <Header network={props.network}  changenetwork={props.changenetwork} 
                confirm={props.confirm} confirmbutton={props.confirmbutton}
                hide={props.hide}
          button={props.button}
                 />
                    
                <section className='page-section hero mb-3' id="hero">
                    <div className='container text-start'>
                        <h1><span className='sub-highlight' style={{ borderBottom:"10px solid #808000"}} >Create your Ethereum Token</span></h1>
                        <p>
                            Easily deploy your Smart Contract for a Standard, Capped, Mintable, Burnable ERC20 Token.
                            <br/>No login. No setup. No coding required.
                        </p>
                    </div>
                </section>
                <CreateToken network={props.network}  changenetwork={props.changenetwork} confirm={props.confirm} confirmbutton={props.confirmbutton} />
                <Footer/>
                </div>
        </>
    )
}